import { TPAComponentProps } from '../../types';
import { ErrorMessageWrapperProps } from '../internal/ErrorMessageWrapper';

export interface RangeProps extends TPAComponentProps {
  /**
   * An array with two numbers of the selected range
   */
  value?: number[];
  /**
   * Min value which can be selected in range
   */
  min?: number;
  /**
   * Max value which can be selected in range
   */
  max: number;
  /**
   * Format in which value numbers should be displayed.
   * It should be used if you want to display numbers in currency format.
   * This prop maps to Intl.NumberFormat params.
   */
  format?: {
    locale?: string;
    style: string;
    currency: string;
  };

  /**
   * Label displayed above component
   */
  label?: string;
  /**
   * Indicator whether to display component in disabled state
   */
  disabled?: boolean;
  /**
   * Callback function which is called upon every value change
   */
  onChange?(value: number[]): void;
  /**
   * Callback function which will be called when ontouchend or onmouseup is triggered
   */
  onAfterChange?(value: number[]): void;
  /**
   * aria-label attribute value for min value handle
   */
  minAriaLabel?: string;
  /**
   * aria-label attribute value for max value handle
   */
  maxAriaLabel?: string;
  /**
   * Error message to display when there is an error. If empty, there isn't an error
   */
  errorMessage?: string;
  /** Appearance of error message. TextOnly | BackgroundAndBorder */
  errorAppearance?: ErrorMessageWrapperProps['errorAppearance'];
}

export const RangeDataHooks = {
  Label: 'label',
  SelectedMinValue: 'selected-min-value',
  SelectedMaxValue: 'selected-max-value',
  errorMessageWrapper: 'errormessagewrapper-message',
};
